export class OCRImageDTO {
  meanConfidence: string;
  text: string;
}
